import React from 'react';
import classNames from 'classnames';

const toneClassNames = {
  auto: 'nima-inline-spinner--auto',
  brand: 'nima-inline-spinner--brand',
  light: 'nima-inline-spinner--light',
  teal: 'nima-inline-spinner--teal'
};

/**
 * Spinner compacto de 14-20px para acoes inline e linhas de componente.
 *
 * Porte de MVF/packages/ui/src/shared/loading/NimaInlineSpinner.tsx.
 */
const NimaInlineSpinner = ({
  label = 'Carregando…',
  size = 'md',
  tone = 'auto',
  className,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  ...props
}) => {
  const decorative = ariaHidden === true || ariaHidden === 'true';
  const announcedLabel = ariaLabel || label;
  const visual = (
    <span
      aria-hidden="true"
      className={classNames(
        'nima-inline-spinner',
        'nima-inline-spinner--' + size,
        toneClassNames[tone]
      )}
    />
  );

  if (decorative) {
    return (
      <span {...props} aria-hidden="true" className={className}>
        {visual}
      </span>
    );
  }

  return (
    <span {...props} className={className} role="status" aria-live="polite" aria-atomic="true">
      {visual}
      <span className="nima-sr-only">{announcedLabel}</span>
    </span>
  );
};

export default NimaInlineSpinner;
